<oui-stepper
  [steps]="steps"
  [displayNumbers]="false"
  direction="vertical"
  (currentStepChange)="onStepChange($event)"
  #stepper></oui-stepper>
